@let hasShiftUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Shift);

<button
  nz-button
  nzType="default"
  class="w-100 fw-normal"
  (click)="triggerAssignMultiShifts.emit()"
  [disabled]="
    !hasShiftUpdatePermission ||
    !(selectedShifts | canAllShiftBeModified) ||
    isOperationOnGoing
  "
  nz-tooltip
  [nzTooltipTitle]="
    !hasShiftUpdatePermission ? ('general.forbidden_action' | translate) : ''
  "
>
  {{ 'shift.page.assign_shifts_header' | translate }}
</button>
